<template>
    <div class="bg-f9f9f9">
        <Mainlayout></Mainlayout>
        <br /> <br /> <br /> <br />
        <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
    
            <CCard class="bg-white b-20" style="border:none">
                <h3 class="custom-48px-400 mt-5"> {{ $t('Announcement Board') }}
                    <!-- <label class="custom-48px-600">{{ $t('Board') }}</label> -->
                </h3>
    
                <label class="text-center custom-label-grey"> {{ $t('details_announcement') }}</label>
                <CRow class="m-3">
                    <CCol sm="6" v-for="item in announcement" v-bind:key="item.Id">
                        <CCard class="border-f5f5f5 m-2">
                            <div class="text-left m-2">
                                <img src="../assets/img/defaultteam.png" style="max-width:80px" />
                                <h3 class="custom-20px-600 font-color-171717">
                                    {{ item.Title }}
                                </h3>
                                <h5 class="custom-18px-400 font-color-858585">
                                    {{ item.Description }}
                                </h5>
                            </div>
                        </CCard>
                    </CCol>
                </CRow>
            </CCard>
        </CCol>
    
    
      
    
        <div v-if="isPopupTeam" class="popup-all backdrop-all">
            <div class="popup-all2">
                <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                </div>
    
                <!-- Popup content -->
                <div class="custom-scroll">
                    <div class="text-left" v-for="item in detailTeam" v-bind:key="item.Id">
                        <CRow>
                            <CCol sm="1"><img src="../assets/img/defaultteam.png" style="max-width:50px" /></CCol>
                            <CCol sm="11">
                                <h3 class="custom-20px-600 text-left mt-2">{{ item.TeamName }}</h3>
                            </CCol>
                        </CRow>
    
                            <div class="m-1">
                                <table class="table p-20 table-responsive-sm" style="width:100% !important">
                                    <thead style="background-color: #064BB4;color:#fff">
                                        <th>No</th>
                                        <th>Player Name</th>
                                        <th>Sport Category</th>
                                        <th>ID Number</th>
                                        <th>Ranking Point</th>
                                        <th>Ranking No</th>
                                        <th>Status</th>
                                    </thead>
                                    <tbody v-for="(items, index) in item.ListTeam" v-bind:key="items.Id">
                                        <tr>
                                            <td>{{ index +1 }}</td>
                                            <td>{{items.Name }}</td>
                                            <td>{{ items.Category }}</td>
                                            <td>{{ items.IdentityNumber }}</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <img src="../assets/img/triangle2.png" style="max-width:10px" />
                                            </td>
                                        </tr>
    
                                    </tbody>
                                </table>
                            </div>
                     
                    </div>
                </div>
            </div>
        </div>
    
    
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            announcement: [],
            tour: [],
            team: [],
            detailTeam: [],

            isPopupTeam: false

        };
    },
    created() {
        AOS.init();

    },
    async mounted() {

        this.GetListAnnouncement();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },

        GetListAnnouncement() {
            this.$API
                .get(this.$GetListAnnouncement)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.announcement = response.data;
                    }
                });
        },
       
        OpenTeam(item) {
            this.GetListTeamById(item.Id);
            this.isPopupTeam = true;
        },
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        GetListTeamById(id) {
            this.$API
                .get(this.$GetListTeamById + "?id=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.detailTeam = response.data;
                    }
                });
        },
        closePopup() {
            this.isPopupTeam = false;
        }



    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>